// extracted by mini-css-extract-plugin
module.exports = {"wo6or09":"wo6or09"};